import { createSelector } from 'reselect';
import type { State as TokenState } from './reducers';

/**
 * Only use this for validating if an accessToken exist. But
 * never for using an accessToken.
 */
const getToken = (state) => {
  const { tokens }: { tokens: TokenState } = state;
  return tokens;
};

export const hasAccessTokenSelector = createSelector(
  [getToken],
  (token) =>
    token &&
    token.accessToken !== undefined &&
    token.accessToken !== null &&
    token.accessToken !== 'null' &&
    token.accessToken !== ''
);
